import { Typography } from "@fullscreendigital/carrefour-dex-fe"
import { URLS } from '../../../constants'
import { generatePath, useNavigate, useSearchParams } from "react-router-dom"
import { TitleHeader } from '../../../Common/TitleHeader'
import { makeCoreGetRequest } from "../../../../../../utils/api"
import { formatErrorMessage } from '../../../../../../utils/formatting'
import { useNotification } from '../../../../../../hooks'
import { useQuery } from 'react-query'
import { CircularProgress, Container, Paper, TextField, InputAdornment } from "@mui/material"
import { Grid } from '@mui/material'
import React from "react"
import SearchIcon from '@mui/icons-material/Search'

const SupplierList = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()

  const [sp, setSp] = useSearchParams()
  const q = sp.get('q') || ''

  const { data: supplierList, isLoading } = useQuery(
    'supplierList',
    async () => {
      return await makeCoreGetRequest('/shop-reception-mobile/ds-direct-supplier/list', null)
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching direct suppliers. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const onSearchChange = React.useCallback((e) => {
    const next = e.target.value
    const nextParams = new URLSearchParams(sp)
    if (next) nextParams.set('q', next)
    else nextParams.delete('q')
    setSp(nextParams, { replace: true })
  }, [sp, setSp])

  const filteredSuppliers = React.useMemo(() => {
    const list = supplierList ?? []
    const term = q.trim().toLowerCase()
    if (!term) return list

    return list.filter((s) =>
      String(s.supplierCode).toLowerCase().includes(term) ||
      String(s.supplierName).toLowerCase().includes(term)
    )
  }, [supplierList, q])

  if (isLoading) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  return (
    <Container maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title="Selecteazǎ Furnizor" />
        </Grid>

        <Grid item xs={12}>
          <TextField
            value={q}
            onChange={onSearchChange}
            placeholder="Caută furnizor"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              )
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Container maxWidth="xs">
            <Grid container spacing={1}>

              {filteredSuppliers.length === 0 && (
                <Grid item xs={12}>
                  <Typography variant="medium" component="p" style={{ margin: '10px' }}>
                    Niciun furnizor{q ? ` pentru “${q}”` : ''}.
                  </Typography>
                </Grid>
              )}

              {filteredSuppliers.map((supplier: any) => (
                <Grid item xs={12} key={supplier.supplierCode}>
                  <Paper
                    elevation={3}
                    style={{ margin: '10px', padding: '20px', cursor: 'pointer' }}
                    onClick={() => {
                      navigate(generatePath(URLS.AUTH_SUPPLIERS_RAYON_LIST, { id: supplier.supplierCode }))
                    }}
                  >
                    <Typography variant="medium" component="h5">
                      {supplier.supplierCode}
                    </Typography>
                    <Typography variant="medium" component="p">
                      {supplier.supplierName}
                    </Typography>
                  </Paper>
                </Grid>
              ))}

            </Grid>
          </Container>
        </Grid>
      </Grid>
    </Container>
  )
}

export default SupplierList
